import { render } from "./PlatinumServiceCategoryItem.vue?vue&type=template&id=2a94eedb&scoped=true"
import script from "./PlatinumServiceCategoryItem.vue?vue&type=script&lang=js"
export * from "./PlatinumServiceCategoryItem.vue?vue&type=script&lang=js"

import "./PlatinumServiceCategoryItem.vue?vue&type=style&index=0&id=2a94eedb&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a94eedb"]])

export default __exports__